<div class="container-fluid background-login">
    <div class="d-flex justify-content-center h-100">
        <div class="card card-orrizontal card-position center">
            <div class="card-body">
                <div class="row ">
                    <div class="col-lg-6 col-md-6 d-none d-md-block img-fluid" style="width: 346px;">
                        <img src="/assets/images/login-315x300.png" alt="">
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <img alt="Immagine login" class="img-login" src="/assets/images/Logo.png">
                        </div>
                        <div class="my-3">
                            <h1 class="my-0">
                                Benvenuto
                            </h1>
                            <sub>Accedi con Google</sub>
                        </div>
                        <div class="my-2">
                            <div id="googleBtn" class="btn text me-3"></div>
                        </div>
                        <div class="my-3">
                            <div class="alert alert-warning mt-3 py-2" role="alert">
                                <i class="fas fa-exclamation-triangle me-2"></i>
                                <h6 class="my-0">È disponibile una nuova versione dell’Area Admin</h6>
                                <p>Per accedere, utilizza le credenziali che ti sono state abilitate.</p>
                            </div>
                            <a href="https://stores-be.fastweb.it/" class="btn btn-outline-primary">Accedi ora alla nuova Area Admin</a>

                        </div>
                    </div>
                </div>
            </div>
            <div class=" card-footer text-muted" [hidden]="!isVisibleError">
                <div class="alert alert-danger" role="alert">
                    {{ error }}
                </div>
            </div>
        </div>
    </div>
    <app-spinner></app-spinner>
</div>